/* eslint-disable jsx-a11y/anchor-is-valid */
import secondaryComponents from "../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import useReturns from "./useReturns";
import primaryComponents from "../../../../components/primaryComponents";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { PlusIcon } from "../../../../assets/svgIcons";
import { RoutedModal } from "../../../../components/common";

const Returns = () => {
  const {
    storeList,
    isLoadingReturns,
    returns,
    metaDetails,
    isReturn,
    search,
    setIsReturn,
    gotoPage,
    filterByStoreId,
    filterByDate,
    filterBySearch,
    filterByKey,
    startDate,
    endDate,
    returnStatusTabs,
    pendingCount,
  } = useReturns();

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Returns"
      description="View of all Returns"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`${globalStyles.pageColumnGaps}`}
        >
          <div>
            <h4 className="mb-0">Returns</h4>
            <p>Record products returned by your customers.</p>
          </div>

          {/* Top Status Tabs Filter */}
          <div className={globalStyles.rowNavigations}>
            {returnStatusTabs?.map((item, index) => (
              <a
                key={index}
                className={`${globalStyles.rowNavigations__item} ${
                  (search.get("status") || "ALL") === (item?.value || "ALL")
                    ? globalStyles.active
                    : ""
                }`}
                onClick={() =>
                  filterByKey(
                    "status",
                    !item?.value || item?.value === "ALL" ? null : item?.value,
                  )
                }
              >
                {item?.label}{" "}
                {item?.value === "REVIEW" && pendingCount > 0 ? (
                  <span className={`ml-1 ${globalStyles.noOfPends}`}>
                    {pendingCount}
                  </span>
                ) : null}
              </a>
            ))}
          </div>

          <div className={globalStyles.pageHeaders}>
            <p>{metaDetails?.total || 0} Returns</p>

            <secondaryComponents.NavigateWithPermission
              permissionParentKey={"Inventory Management"}
              permissionChildKey="can_return_products"
            >
              <primaryComponents.Button
                classNames={"btn btn--primary ml-auto"}
                onClick={() => setIsReturn(true)}
              >
                <PlusIcon className="mr-1" /> Return Product
              </primaryComponents.Button>
            </secondaryComponents.NavigateWithPermission>
          </div>

          {/* table section */}
          <div className={`${globalStyles.tableWrapper}`}>
            <div className={`${globalStyles.tableHeader}`}>
              <primaryComponents.SearchField
                classNames={`${globalStyles.searchField}`}
                placeholder="Search by order or request ID"
                trigger={(value) => filterBySearch(value)}
                value={search.get("query") || ""}
                triggerOnInput={true}
                showsearchBtn={true}
              />

              <div className="ml-auto" style={{ width: "140px" }}>
                <primaryComponents.SelectField
                  options={[
                    {
                      name: "All stores",
                      id: null,
                    },
                    ...storeList,
                  ]}
                  idKey="id"
                  nameKey="name"
                  onChange={(value) => {
                    filterByStoreId(value);
                  }}
                  value={
                    storeList?.find(
                      (store) => `${store?.id}` === search.get("store_id"),
                    )?.name || "All stores"
                  }
                  floatError={false}
                  isSearchable={false}
                />
              </div>

              <primaryComponents.DateRangeInput
                startDate={startDate}
                endDate={endDate}
                onChange={filterByDate}
              />
            </div>

            {/* table section */}
            <secondaryComponents.LoaderHelper
              isLoading={isLoadingReturns}
              classNames="mt-5"
            >
              <secondaryComponents.ReturnsTable
                returns={returns}
                metaDetails={metaDetails}
                gotoPage={gotoPage}
              />
            </secondaryComponents.LoaderHelper>
          </div>

          {/* add return widget */}
          <RoutedModal
            isActive={isReturn}
            headerTitle="Returns"
            closeModal={() => setIsReturn(false)}
            width={"800px"}
          >
            <secondaryComponents.ReturnStockWidget
              closeWidget={() => setIsReturn(false)}
            />
          </RoutedModal>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};

export default Returns;
